import { type ReactNode } from 'react';
import { Button, type ButtonProps } from '@/components/common';

type ContinueButtonProps = {
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
};

/** Full-width primary CTA for wizard steps — white on gray, ghost variant for secondary actions. */
export function ContinueButton({
  onClick,
  children,
  disabled,
  variant,
  size = 'lg',
}: ContinueButtonProps) {
  const isPrimary = variant == null || variant === 'solid';

  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled}
      color="gray"
      highContrast={isPrimary}
      variant={variant}
      size={size}
      fullWidth
    >
      {children}
    </Button>
  );
}
